module.exports = __webpack_public_path__ + "media/npc_dota_hero_antimage.c7a06245.webm";